import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import type * as React from 'react';
import importedDocumentsFetched, {
	type ImportedDocumentsFetchedAction,
	type ImportedDocumentsPayload,
} from '@Application/Beneficiaries/ImportedDocuments/Actions/importedDocumentsFetched';
import importedDocumentsFetchFailed, {
	type ImportedDocumentsFetchFailedAction,
} from '@Application/Beneficiaries/ImportedDocuments/Actions/importedDocumentsFetchFailed';
import type FetchImportedDocuments from '@Application/Beneficiaries/ImportedDocuments/Queries/FetchImportedDocuments';
import { getPaginated } from '@Domain/Api';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = ImportedDocumentsFetchedAction | ImportedDocumentsFetchFailedAction;

export default (query: FetchImportedDocuments) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			// `rowsPerPage: 200` is the server's maximum accepted `rows` value.
			const payload = await getPaginated<ImportedDocumentsPayload>(
				`${buildSubjectApiPath(query.facilityId, query.subject)}/imported-documents`,
				{ page: 0, rowsPerPage: 200 },
			);

			const action = importedDocumentsFetched(payload, query.subject.subjectId, query.subject.typeKey);
			dispatch(action);
			return action;
		} catch (error) {
			const action = importedDocumentsFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
